const context = require.context('.', true, /\.js$/);
const fields = {};

context.keys().forEach(key => {
  if (key !== './index.js') {
    fields[key.replace(/(\.\/|\.js)/g, '')] = (context(key) || {}).default;
  }
});

export default fields;



// WEBPACK FOOTER //
// ./src/components/Forms/Fields/index.js